import ExternalAnchorUrl from 'models/application/anchor/types/external/types/Url';

export default class ExternalAnchorUrlService {
	toModel(anchor) {
		return new ExternalAnchorUrl(anchor);
	}
}
